export default __webpack_public_path__ + "static/media/customers-active.2914f4ce.svg";